module.exports = __webpack_public_path__ + "static/media/facebook.c10432ec.svg";